
import http from "@/utils/http";

export default {
    login: data => {
        return http({url:'/api/agent/v1/user/login',data}).then(r => r);
    },
    update: data => {
        return http({url:'/api/agent/v1/user/updateInfo',data,tip:true}).then(r => r);
    },
    updatePassword: data => {
        return http({url:'/api/agent/v1/user/updatePassword',data,tip:true}).then(r => r);
    },
}